<ng-template #tplTitle>
  <span>Title Template</span>
</ng-template>
<ng-template #tplContent let-params>
  <p>some contents...</p>
  <p>some contents...</p>
  <p>{{ params.value }}</p>
</ng-template>
<ng-template #tplFooter let-ref="modalRef">
  <button ui-button (click)="ref.destroy()">Destroy</button>
</ng-template>

<button ui-button buttonType="primary" (click)="openTemplate()">Open Modal From Template</button>

<button ui-button buttonType="primary" (click)="openComponent()">Open Modal From Component</button>
